import { render, staticRenderFns } from "./QueryLionC.vue?vue&type=template&id=27031f47&"
import script from "./QueryLionC.vue?vue&type=script&lang=js&"
export * from "./QueryLionC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports